import PropTypes from "prop-types";
// MUI components
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip"; // Import Tooltip
// redux
import { useDispatch, useSelector } from "react-redux";

import { loadProductListState } from "store/features/respondentDashboardSlice";
import { loadProductOrderState, loadProductsVisibility } from "../../store/features/productsInfoSlice";
import { loadIsFilterAcrossProductsForCorrelationState, loadMissingFiltersForCorrelationState, loadCurrentSelectedFiltersForCorrelationState, loadCurrentSelectedAllFiltersForCorrelationState } from "../../store/features/correlationSlice";
import { loadCorrelationRemovedKpiListState } from "../../store/features/analysisKpiSlice";

import { loadWeightToggleForCorrelationState, loadDisableWeightToggleForCorrelationState, loadSelectedCorrelationMethodState } from "store/features/correlationSlice";

function Reset({ resetCorrelation = () => {}, setSelectedBackendVariableForDriverAnalysis = () => {}, getDefaultCorrelationMethod = () => {}, setSelectedColorRanges = () => {}, resetTargetVariable = () => {} }) {
    //REDUX
    const dispatch = useDispatch();

    const selectedStudies = useSelector((state) => state.studyDataStore.selectedStudies);
    const currentFilterForCorrelationStoreData = JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation)) || {};
    const currentFilterAllForCorrelationStoreData = JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedAllFiltersForCorrelation)) || {};
    const defaultProductsOrder = useSelector((state) => state.productsInfoStore.defaultProductsOrder);
    // const defaultCorrelationAnalysisResult = useSelector((state) => state.correlationStore.defaultCorrelationAnalysisResult);
    // const weightToggleForCorrelation = useSelector((state) => state.correlationStore.weightToggleForCorrelation);

    const resetCf = (consumerFilterStr = {}) => {
        const updatedCf = JSON.parse(consumerFilterStr.replaceAll(":true}", ":false}"));
        return updatedCf;
    };

    const resetAllCf = (consumerFilterStr = {}) => {
        const updatedCf = JSON.parse(consumerFilterStr.replaceAll(":true", ":false"));
        return updatedCf;
    };

    // Function to reset color ranges to default state (all true)
    const resetColorRanges = () => {
        setSelectedColorRanges({
            veryHighPositive: true, // 0.70 Above
            highPositive: true, // 0.69 to 0.40
            moderatePositive: true, // 0.39 to 0.10
            lowPositive: true, // 0.09 to 0
            lowNegative: true, // -0.01 to -0.4
            moderateNegative: true, // -0.4 to -0.69
            highNegative: true, // Below -0.70
        });
    };

    const handleReset = () => {
        // Get default correlation method from the prop function
        const defaultMethod = getDefaultCorrelationMethod();

        // Reset correlation method to default
        dispatch(loadSelectedCorrelationMethodState(defaultMethod));

        // Reset target variable to default
        resetTargetVariable();

        // filters
        dispatch(loadIsFilterAcrossProductsForCorrelationState(false));
        dispatch(loadMissingFiltersForCorrelationState({}));
        dispatch(loadCurrentSelectedFiltersForCorrelationState(resetCf(currentFilterForCorrelationStoreData)));
        dispatch(loadCurrentSelectedAllFiltersForCorrelationState(resetAllCf(currentFilterAllForCorrelationStoreData)));

        // product visibility
        dispatch(loadProductOrderState(defaultProductsOrder));
        dispatch(loadProductsVisibility({}));

        // kpi visibility
        dispatch(loadCorrelationRemovedKpiListState([]));

        //clear checkbox selections
        setSelectedBackendVariableForDriverAnalysis([]);

        //Reset color ranges to default state
        resetColorRanges();

        // respondent
        dispatch(loadProductListState([]));

        // weight toggle
        const arr = [];
        selectedStudies.forEach((item) => {
            arr.push(item?.["weighted"]);
        });
        const flag = arr.some((ele) => ele === true);
        if (flag) {
            dispatch(loadWeightToggleForCorrelationState(flag));
            dispatch(loadDisableWeightToggleForCorrelationState(!flag));
            resetCorrelation(null, [], {}, flag, null);
        }
    };
    return (
        <Tooltip
            title="Reset Default Study View"
            placement="top-end"
        >
            <Button
                size="small"
                className="custom-btn liner-light-blue-background me-4 bold-content"
                variant="contained"
                onClick={handleReset}
            >
                Reset
            </Button>
        </Tooltip>
    );
}
Reset.propTypes = {
    resetCorrelation: PropTypes.func,
    setSelectedBackendVariableForDriverAnalysis: PropTypes.func,
    getDefaultCorrelationMethod: PropTypes.func,
    setSelectedColorRanges: PropTypes.func,
    resetTargetVariable: PropTypes.func,
};
export default Reset;
